import { ClipboardInput, ClipboardLabel, ClipboardRoot, IconButton } from '@chakra-ui/react'
import * as NativeClipboard from './native'
import { Group } from '..'
import { UI } from 'components'

export default function Clipboard({ label, colorPalette, inputProps = {}, ...props }){
    return(
    <NativeClipboard.ClipboardRoot {...props}>
        <NativeClipboard.ClipboardLabel children={label} />
        <Group width="full" endElement={<NativeClipboard.ClipboardIconButton me="-2" colorPalette={colorPalette} />}>
            <NativeClipboard.ClipboardInput {...inputProps} />
        </Group>
    </NativeClipboard.ClipboardRoot>
    )
}